<template>
  <b-row align-h="end">
    <b-col md="4" align-self="end">
      <h4>{{ title }}</h4>
    </b-col>
    <b-col md="4" class="p-0">
      Từ
      <b-form-datepicker
        v-model="begin"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        }"
        locale="vi"
      ></b-form-datepicker>
    </b-col>
    <b-col md="4" class="p-0">
      Đến
      <b-form-datepicker
        v-model="end"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        }"
        locale="vi"
      ></b-form-datepicker>
    </b-col>
  </b-row>
</template>
<script>
import { addDateTime } from '@/utils/date';
export default {
  name: 'date-range',
  props: {
    title: {},
    value: {}
    // value: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       begin: addDateTime(-3),
    //       end: new Date()
    //     };
    //   }
    // }
  },
  data() {
    return {
      first: true,
      begin: this.value && this.value.from,
      end: this.value && this.value.to
    };
  },
  mounted() {
    this.first = true;
    this.begin = this.value && this.value.from ? this.value.from : addDateTime(-3);
    this.end = this.value && this.value.to ? this.value.to : new Date();
    this.$emit('input', {
      from: this.begin,
      to: this.end
    });
  },
  watch: {
    begin: function() {
      if (!this.first) {
        this.$emit('input', {
          from: this.begin,
          to: this.end
        });
      }
    },
    end: function() {
      if (!this.first) {
        this.$emit('input', {
          from: this.begin,
          to: this.end
        });
      }
      this.first = false;
    }
  }
};
</script>
